import { createNullableContext } from '~/common/contexts/nullableContext';
import { DealConfigsContextType } from './types/DealConfigsContextType';

export const DealConfigsContext =
  createNullableContext<DealConfigsContextType>();
